export default {
  "aor": {
    "action": {
      "add_filter": "Добавить фильтр",
      "back": "Назад",
      "cancel": "Отмена",
      "close": "Закрыть",
      "create": "Создать",
      "delete": "Удалить",
      "edit": "Редактировать",
      "list": "Перечислить",
      "refresh": "Обновить",
      "remove_filter": "Удалить этот фильтр",
      "save": "Сохранить",
      "show": "Показать"
    },
    "auth": {
      "avatar": "URL вашей фотографии (опционально)",
      "bio": "Кратко о себе (опционально)",
      "education": "Ваше образование (опционально)",
      "email": "Email",
      "first_name": "Имя (опционально)",
      "last_name": "Фамилия (опционально)",
      "logged_in": "Вы вошли",
      "logged_out": "Вы вышли",
      "logging_in": "Вы вошли",
      "login": "Войти",
      "logout": "Выйти",
      "name": "Имя",
      "password": "Пароль",
      "sign_in": "Войти",
      "sign_in_error": "Войти не удалось, пожалуйста, попробуйте снова",
      "sign_up": "Зарегистрироваться",
      "sign_up_error": "Зарегистрировать не удалось, пожалуйста, попробуйте снова",
      "signing_up": "Вы зарегистрированы",
      "username": "Username",
      "website": "Веб-сайт (не обязательно)"
    },
    "boolean": {
      "false": "Нет",
      "true": "Да"
    },
    "edit_profile": "Редактировать профиль",
    "input": {
      "autocomplete": {
        "none": ""
      },
      "file": {
        "upload_several": "Перетащите несколько файлов для загрузки или кликните, чтобы выбрать один.",
        "upload_single": "Перетащите файл для загрузки или кликните, чтобы выбрать его."
      },
      "image": {
        "upload_several": "Перетащите несколько картинок для загрузки или кликните, чтобы выбрать одну.",
        "upload_single": "Перетащите картинку для загрузки или кликните, чтобы выбрать её."
      }
    },
    "message": {
      "about": "О проекте",
      "are_you_sure": "Вы уверены?",
      "no": "Нет",
      "not_found": "Вы ввели некорректный URL или прошли по битой ссылке.",
      "yes": "Да"
    },
    "navigation": {
      "next": "Листать вперёд",
      "no_more_results": "Больше результатов не найдено",
      "no_results": "Эта сущность не менялась: в истории изменений нечего показывать",
      "page_out_from_begin": "Нет страницы раньше первой",
      "page_out_from_end": "Нет страницы дальше последней",
      "page_out_of_boundaries": "Страница номер %{page} вышла за пределы",
      "page_range_info": "%{offsetBegin}-%{offsetEnd} из %{total}",
      "prev": "Листать назад"
    },
    "notification": {
      "created": "Успешно создано",
      "deleted": "Успешно удалено",
      "http_error": "Ошибка соединения с сервером",
      "item_doesnt_exist": "Элемент не существует",
      "updated": "Успешно обновлено"
    },
    "page": {
      "create": "Создать %{name}",
      "dashboard": "Панель инструментов",
      "delete": "Удалить %{name} #%{id}",
      "edit": "%{name} #%{id}",
      "list": "Список %{name}",
      "not_found": "Не найдено",
      "show": "%{name} #%{id}"
    },
    "profile_image": "Аватар",
    "validation": {
      "email": "Должно быть корректным email",
      "maxLength": "Должно быть не длиннее %{max} символов",
      "maxValue": "Должно быть не больше %{max}",
      "minLength": "Должно быть не корочк %{min} символов",
      "minValue": "Должно быть не менее %{min}",
      "number": "Должно быть числом",
      "required": "Обязательно"
    }
  },
  "askQuestion": "Задайте вопрос",
  "auth": {
    "logged_in": "Вы вошли",
    "logged_out": "Вы вышли",
    "login": "Вход",
    "logout": "Выход",
    "sign_in": "Войти",
    "sign_up": "Присоединиться"
  },
  "chartSunburst": {
    "breakdownTitle": "%{dontTranslate} человек по принадлежности",
    "hoverClickItems": "наведите/кликните на сектор",
    "switchChart": "ТИП ДИАГРАММЫ"
  },
  "influence": {
    "year": "Год",
    "provinces": "Области",
    "populationTotal": "Общее население",
    "populationShare": "Доля населения",
  },
  "community": {
    "biographyShort": "О себе",
    "board": "Форум",
    "highscore": "Рейтинг участников",
    "memberSince": "участник с",
    "myProfile": "Мой профиль",
    "supportingMember": "Участники, поддерживающие проект",
    "totalPoints": "Общий счёт",
    "loginCount": "Число входов",
    "voteCount": "Число голосов",
    "createCount": "Число добавлений",
    "editCount": "Число изменений",
    "deleteCount": "Число удалений",
    "mistakesCount": "Число ошибок",
    "revertCount": "Число отмен",
    "linkedCount": "Число ссылок",
  },
  "didYouKnow": {
    "escape": "You can close opened articles by pressing Escape key",
    "coloring": "При помощи значка «Слои» в меню вы можете поменять раскраску карты, чтобы цветами были размечены не страны, а различные религии, культуры или население",
    "discover": "Вы можете исследовать изображения и другие мультимедийные материалы, щелкнув на значок компаса в меню",
    "distribution": "Вы можете посмотреть распределение людей по принадлежности, щёлкнув значок круговой диаграммы на статье",
    "link": "Вы можете связать статьи, чтобы показать их в оглавлении статьи или в разделе мультимедийных материалов",
    "markerlimit": "Вы можете улучшить быстродействие сайта, уменьшив число отображаемых меток в разделе «Слои»",
    "province": "Вы можете посмотреть полную историю области, щёлкнув на вкладку «Область» в заголовке статьи",
    "question": "Вы можете задавать вопросы о статьях и отвечать на чужие вопросы на Форуме",
    "timeline": "Вы можете скроллить таймлайн колёсиком мышки, чтобы поменять временной масштаб"
  },
  "introHints": {
    "step1": "Измените масштаб временной шкалы при помощи колеса прокрутки и кликните в любое место на шкале (1/3)",
    "step2": "Откройте меню «Слои» и выберите интересующие вас метки и эпопеи (2/3)",
    "step3": "Откройте меню «Материалы», там вы найдёте изображения, видео и прочие материалы, относящиеся к выбранному году (3/3)",
    "stepFinal": "Теперь вы знаете основы. А множество других возможностей вам ещё предстоит открыть. Приятного путешествия!",
    "close": "Закрыть обучение"
  },
  "benchmarkPage": {
    "tier5Header": "никто",
    "title": "Настройки по умолчанию",
    "tier1Header": "Скорость и минимализм",
    "tier1Description": "Только границы и названия.",
    "tier2Header": "Умеренно",
    "tier2Description": "Границы, названия и до 2000 меток на каждый год.",
    "tier3Header": "Полностью",
    "tier3Description": "Эпопеи на временной шкале, отображать до 5000 меток на каждый год.",
    "hint": "Не беспокойтесь, все настройки можно будет поменять позднее!",
    "suggestion1": "Мы предлагаем <b>%{dontTranslate}</b> на основе ",
    "suggestion2": "характеристики вашей машины",
    warning1: "While mobile support is on our roadmap, we do not have a mobile version yet. Please check back later.",
    warning2: "While tablet support is on our roadmap, we do not support touch screens yet. Please check back later.",
    "continue": "Продолжить",
    "specsTitle": "Характеристики вашей машины",
  },
  "loadingPage": {
    "errorMessage": "Похоже, Chronas сейчас слишком загружен. Пожалуйста, повторите запрос снова через пару минут.",
    "loadingScreenDescription": {
      "218": "Молодой римский император Гелиогабал (203-222 н.э.) устраивает пир",
      "400": "Гонорий, сын Феодосия I Великого; в 393 году Феодосий назначает его младшим августом Западной Римской Империи",
      "450": "450-511: Воспитание детей Хлодвига",
      "711": "711: Сражение Омейядов с вестготами при Гвадалете и начало мусульманского завоевания Пиринейского полуострова",
      "881": "881: Битва датских викингов-язычников с христианскими войсками Каролингов",
      "1121": "1121: Последствия Дидгорской битвы, изображенные на картине «Дух всадника» Аугусто Феррер-Дальмау",
      "1331": "1331: Осада Акасака под Осакой была одним из первых сражений мятежа Гэнко",
      "1582": "1582: Бой на Чувашевом мысу",
      "1627": "1627–1628: Осада Ла-Рошели (Королевство Франция)",
      "1649": "1649: Кромвель в Данбаре. Оливер Кромвель силой объединил все Британские острова и создал Английскую республику",
      "1832": "1832: Мост Пон-Нёф в Париже",
      "1862": "1862: Заключенные Конфедерации, захваченные в плен в сражении при Фронт-Ройале",
      "1871": "1871: Провозглашение Германской империи в Версале",
      "-1400": "1400 до н.э.: Солнечная повозка из Трундхольма - обнаруженный в Дании артефакт скандинавского бронзового века.",
      "-2000": "26 век до н.э.: Штандарт войны и мира из шумерского города Ур - полый деревянный ящик со декорированными панелями сцен войны и мира",
      "-332": "332 до н.э.: Александр Македонский без боя входит в Вавилон",
      "-519": "519 до н.э.: Луций Квинкций Цинциннат стал легендарным противником прав плебеев (простых граждан)",
      "-52": "52 до н.э.: Капитуляция галльского вождя после битвы при Аллезии",
      "-600": "605-562 до н.э.: Шагающий лев, Нововавилонское царство",
      "-620": "620-570 до н.э.: Сафо и Алкей",
      "-668": "668 до н.э.: Скульптурные рельефы с изображением Ашшурбанапала, последнего великого ассирийского царя, охотящегося на львов"
    }
  },
  "pos": {
    "about": "О проекте Chronas",
    "account": "Профиль",
    "addMedia": "Добавить мультимедийный материал",
    "advanced": "Дополнительно",
    "area": "Территория",
    "areaColHeader": "Террит.",
    "areas": "Территории",
    "back": "назад",
    "basemap": "Подложка",
    "basemapTypes": {
      "none": "Нет",
      "topographic": "Топографическая",
      "watercolor": "Акварель"
    },
    "block": {
      "about1": "<h4>Что такое Chronas?</h4> <br /> <h5>Вкратце</h5>",
      "about2": "Можно описать Chronas как помесь <a target='_blank' href='https://www.openstreetmap.org'>Open Street Map</a>, <a target='_blank' href='https://www.wikipedia.org/'>Википедии</a> и <a target='_blank' href='https://earth.google.com/web/'>Google Earth</a>. Он отображает 4000 летнюю историю правительств, культур, и религий на карте со ссылками на соответствующие статьи Википедии, а также показывает метки множества различных типов: люди и битвы, города и замки итп. Все они могут быть соотнесены друг с другом (например, можно связать осаду как событие с меткой соответствующего города). В дополнение, чтобы создать ещё большую сеть знаний, можно привязать такие типы материалов, как видео, изображения и подкасты. Пользователи могут добавлять, редактировать и оценивать метки, территории и мультимедийные материалы, а также создавать ссылки между объектами, и всё это отслеживается системой управления версиями. Также пользователи могут задавать вопросы к отдельным статьям и создавать подборки статей (эпопеи) по крупным темам, таким как войны или исследования территорий. Такие сущности как религия (культура/правитель) также можно рассматривать как эпопеи, показывающие распространение религии в определенный период времени. Видео, демонстрирующее эти возможности, можно посмотреть ",
      "about3": "здесь",
      "about4": "<h5>Истоки</h5><p>Название <b>Chronas</b> - это комбинация слов <b>Хрон</b>ос и Атл<b>ас</b>, что указывает на хронологический и картографический подходы исторического приложения.</p><p>Изначальная идея из середины 2014-го была в том, чтобы добавить на приложение вроде Google Карт слайдер времени, чтобы можно было путешествовать назад во времени и наблюдать, как государства основываются, растут и исчезают. Моей целью было лучше понять, как связаны события мировой истории. <i>Что происходило в Азии, когда в Европе господствовал Рим? Что было в Аравии, когда Хубилай провозгласил себя императором Китая</i></p><p>Первая версия Chronas была выпущена в 2015-м и привлекла более 5000 зарегистрировавшихся пользователей. Она была основана на форке <a target='_blank' href='https://umap.openstreetmap.fr/en'>Open Street Map</a> и использовала библиотеку растровых карт <a target='_blank' href='https://leafletjs.com/'>Leaflet</a> с реляционной базой данных <a target='_blank' href='https://www.postgresql.org/'>PostgreSQL</a>.</p><p>Вот 5-минутное видео, демонстрирущее основные возможности оригинальной версии:</p>",
      "about5": "<p>Если вы хотите испробовать оригинальную версию, она всё ещё доступна по ссылке <a target='_blank' href='http://v0.chronas.org'>http://v0.chronas.org</a>. Она также включает в себя <a target='_blank' href='http://v0.chronas.org/blog'>блог разработки</a>, который более подробно объясняет технический подход первоначальной версии, а также два сопутствующих 3D приложения, показывающих <a target='_blank' href='http://app.chronas.org/castles/#/wikidata'>замки</a> и <a target='_blank' href='http://app.chronas.org/battles/#/wikidata'>битвы</a> на языке википедии.</p><br /><p>Разработка текущей версии Chronas началась в июле 2017 и состояла в полном переписывании логики и архитектуры с фокусом на улучшении производительности и упрощении внесения правок, версионировании и связывании статей на смежные темы. Вместо Leaflet теперь используется картографическая WebGL библиотека <a target='_blank' href='https://www.mapbox.com/mapbox-gl-js/api/'>Mapbox GL</a> в паре с интерфейсом на базе <a target='_blank' href='https://reactjs.org/'>React JS</a>. В роли бэкенда выступает специальное API, написанное на <a target='_blank' href='https://expressjs.com'>Express</a> <a target='_blank' href='https://nodejs.org/'>Node JS</a>, использующее NoSQL базу данных <a target='_blank' href='https://nodejs.org/'>Mongo</a> для сложных запросов и контроля версий.</p><p>Подробное описание возможностей новой версии Chronas можно найти в разделе <b>«Инструкция»</b>.</p>",
      "contact1": "Разработчики",
      "contact10": "Отправить",
      "contact2": "Разработка фронтенда и бэкенда",
      "contact3": "DevOps и поддержка в развитии проекта",
      "contact4": "Переведено",
      "contact5": "Написать",
      "contact6": "Вы можете отправить нам Email напрямую (чтобы увидеть наши почтовые адреса, наведите мышкой на иконку с конвертом) или воспользоваться формой ниже:",
      "contact7": "Ваш Email*",
      "contact8": "Тема*",
      "contact9": "Сообщение*",
      "howTo1": "Как использовать (5 минут)",
      "howTo2": "Как редактировать данные (6 минут, с комментариями на английском)",
      "pledge1": "Вы используете Chronas вот уже <b>15 минут</b>!",
      "pledge2": "Существование и развитие Chronas зависят от поддержки пользователей. Если вы находите проект полезным, зайдите на ",
      "pledge3": " и рассмотрите возможность поддержки проекта любой суммой.",
      "pledge4": "Жертвователи получают возможность направлять проект, голосуя за крупные решения о дизайне проекта и расставлять приоритеты в разработке нового функционала.",
      "pledge5": "Если вам не нравится Patreon, можно сделать одноразовое пожертвование через PayPal:",
      "rules1": "<br /><h4>Правила курирования данных</h4><ol><li><i>Никакого вандализма</i>: Это неподходящее место для того, чтобы рисовать карты альтернативной истории. Вандализм безмерно вредит проекту (так как требует дорогостоящего резервного копирования), так что вы будете заблокированы.</li><li><i>Посмотрите обучающие видео</i>, прежде чем приступать к редактированию. Некоторые элементы управления могут привести к <i>нежелательным</i> результатам.</li><li>Данные, которые вы вносите должны быть основаны на <i>общепринятой истории</i>, вы должны быть готовы привести свои источники.</li><li><i>Сообщайте</i> о пользователях, нарушающих эти правила.</li></ol><br /><h4>Правила форума</h4><ol><li><i>Никакого вандализма</i>: воздержитесь от расизма, фанатизма и оскорбительного поведения.</li><li>Формулируйте вопросы <i>чётко и конкретно</i>, с указанием <i>времени и места</i>.</li><li>Если вас спросят про источники, отдавайте предпочтение <i>первичным и вторичным источникам</i>, а не третичным, таким как <i>Википедия</i>.</li><li>Только серьезные вопросы по теме: <i>никаких шуток</i>, <i>анекдотов</i>, <i>бессмысленного трёпа</i>, и прочих <i>отклонений от темы</i>.</li><li><i>Сообщайте</i> о комментариях, нарушающих эти правила.</li></ol>",
      "statistics1": "Эта статистика отображает слепок текущей базы данных Chronas в реальном времени",
      "statistics2": "Элементы карты",
      "statistics3": "Пользователи и взаимодействия",
      "statistics4": "Распределение меток",
      "statistics5": "Элементы карты",
      "statistics6": "Подробности",
      "statistics7": "Распределение мультимедиа",
      "statistics8": "Авторизация пользователей",
      "statisticsTooltip1": "Данные областей: по 5 характеристик для 2479 областей за 4000 лет",
      "statisticsTooltip2": "Метки включают в себя метки людей и битвы, а также города итп",
      "statisticsTooltip3": "Сюда входят мультимедийные материалы, а также эпопеи (подборки статей)",
      "statisticsTooltip4": "Число уникальных сущностей правителей, религий и культур",
      "statisticsTooltip5": "Зарегистрированные пользователи",
      "statisticsTooltip6": "Правки данных, сделанные пользователями",
      "statisticsTooltip7": "Ветки форума (включая автоматически сгенерированные и перемещенные ветки)",
      "statisticsTooltip8": "Комментарии форума (включая автоматически сгенерированные и перемещенные ответы)",
      "support1": "Есть разные способы финансировать поддержку, починку багов и развитие нового функционала. К примеру, Wikipedia и общественные каналы используют <b>повторяющиеся кампании</b> по сбору пожертвований, многие веб-приложения прибегают к <b>рекламе</b> (что может ухудшать удобство использования и портить удовольствие от использования приложения). Другой путь - создание <b>профессиональной версии</b> или попытка найти <b>венчурных инвесторов</b>.",
      "support10": " разработчикам.",
      "support11": "Если вы хотите запустить Chronas на своём (или нашем) сервере с полной копией данных и полным контролем над ними, ",
      "support12": "напишите",
      "support13": " нам, мы будем рады обсудить этот вопрос",
      "support2": "Мы решили испробовать другую модель финансирования, которая даёт <b>поддерживающим проект пользователям</b>, обеспечивающим будущее Chronas, возможность решать, куда ведёт это путешествие. Если вы верите в наш проект, пожалуйста, подумайте о том, чтобы нас поддержать",
      "support3": ", где будут проходить регулярные <b>опросы</b> о приоритете предложенных <b>новых возможностей</b>, а также <b>крупных решений о дизайне</b> проекта.",
      "support4": "Если вас не устраивает Patreon, вы можете внести единоразовое пожертвование посредством PayPal:",
      "support5": "Новый функционал",
      "support6": "Вы можете предожить новый функционал в разделе «Предложить функционал» на ",
      "support7": "форуме",
      "support8": " или прямо ",
      "support9": "написать",
      "welcome11": "<b>Chronas</b> - это историческая карта, имеющая больше ",
      "welcome12": "50 миллионов точек",
      "welcome13": ", которые каждый зарегистрированный пользователь может курировать и добавлять (прямо как в <a>Википедии</a>).",
      "welcome21": "Прежде чем погрузиться посмотрите короткое ",
      "welcome22": "обучающее видео",
      "welcome23": " в разделе «Инструкция».",
      "welcome31": "Присоединяйтесь",
      "welcome32": " к нашему сообществу из вот уже <b>%{dontTranslate}</b> участников, чтобы добавлять и редактировать данные, зарабатывать очки, задавать вопросы по историческим статьям и получить доступ к нашим ",
      "welcome33": "Форумам",
      "welcome34": ", чтобы предлагать новый функционал и сообщать о багах.",
      "welcome41": "Заходите в раздел ",
      "welcome42": "«О проекте»",
      "welcome43": ", чтобы узнать о Chronas больше или отправить разработчикам ваши вопросы, предложения и комментарии посредством формы обратной связи в разделе ",
      "welcome44": "«Контакты»",
      "welcome45": ".",
      "welcome51": "Мы верим в потенциал проекта стать популярным инструментом изучения истории наряду с Википедией. Если вы разделяете наш энтузиазм и хотели бы увидеть успех этого проект, пожалуйста подумайте о том, чтобы стать спонсором проекта. В разделе ",
      "welcome52": "«Поддержать»",
      "welcome53": " вы можете получить больше информации о <b>будущем проекта</b> и возможностях <b>поддержать</b> его."
    },
    "clusterMarker": "Группировать метки",
    "community": "Форум сообщества",
    "configuration": "Настройка",
    "discover": "Исследовать",
    "discover_component": {
      "seeMore1": "See more media in the ",
      "seeMore2": " section...",
      "noFound": "No images found",
      "noGeotaggedFound": "No geotagged images found in this location, see Discover section for all available images",
      "edit": "Редактировать этот объект",
      "hasNoArticle": "К объекту ещё не привязана вики-статья, пожалуйста отредактируйте этот объект",
      "hasNoSource": "К объекту ещё не привязаны источники информации, пожалуйста отредактируйте этот объект",
      "openArticle": "Открыть соответствующую статью в Википедии",
      "openSource": "Открыть источник в новой вкладке",
      "tabs": {
        "HIGHLIGHTS": "ГЛАВНОЕ",
        "ARTEFACTS": "АРТЕФАКТЫ",
        "EPICS": "ЭПОПЕИ",
        "PEOPLE": "ЛЮДИ",
        "CITIES": "ГОРОДА",
        "BATTLES": "БИТВЫ",
        "OTHER": "ДРУГОЕ",
        "VIDEOS": "ВИДЕО",
        "PRIMARY SOURCES": "ПЕРВОИСТОЧНИКИ"
      }
    },
    "discover_label": "Исследовать год ",
    "downvote": "Неуместно, некорректно или испорчено",
    "edit": "Редактировать",
    "epicIdNameArray": {
      "ee": "Исследование территорий",
      "ei": "Открытие",
      "eo": "Другая эпопея",
      "es": "Первоисточник",
      "ew": "Война"
    },
    "epics": "Эпопеи",
    "migration": "Миграция",
    "feedbackSuccess": "Спасибо за курирование данных!",
    "filter": "Фильтровать",
    "filterMedia": "Фильтровать мультимедийные материалы",
    "fontType": "Тип шрифта",
    "founded": "осн.",
    "fullscreenArticle": "Смотреть статью в полноэкранном режиме",
    "general": "Основные настройки",
    "goFullScreen": "Полноэкранный режим",
    "goTutorial": "Перейти к обучению",
    "help": "Введение и информация",
    "images": "Изображения",
    "info": {
      "followUs": "Следите за нами в",
      "lastDataEdit": "последнее исправление данных",
      "tabs": {
        "about": "О проекте",
        "contact": "Контакты",
        "howTo": "Инструкция",
        "rules": "Правила",
        "statistics": "Статистика",
        "support": "Поддержать",
        "welcome": "Введение"
      },
      "welcomeTo": "Добро пожаловать в"
    },
    "information": "Информация",
    "label": "Подпись",
    "language": "Язык",
    "layers": "Слои",
    "linkedTypes": {
      "artefacts": "[Изображение] Артефакт",
      "audios": "[Подкаст & аудио]",
      "battles": "[Изображение] Битва",
      "cities": "[Изображение] Город & здание",
      "eb": "[Эпопея] Биография",
      "ee": "[Эпопея] Исследование территорий",
      "ei": "[Эпопея] Открытия",
      "eo": "[Эпопея] Другое",
      "ew": "[Эпопея] Войны",
      "h": "[HTML или текст]",
      "misc": "[Изображение] Другое",
      "o": "Другое",
      "people": "[Изображение] Персона",
      "ps": "[Ссылка] Первоисточник",
      "v": "[Видео]",
      "w|a": "[Вики-статья] Люди -> Деятели искусства",
      "w|ar": "[Вики-статья] Артефакты",
      "w|at": "[Вики-статья] Люди -> Спортсмены",
      "w|b": "[Вики-статья] Битвы -> Битвы",
      "w|c": "[Вики-статья] Города -> Города",
      "w|ca": "[Вики-статья] Города -> Замки",
      "w|e": "[Вики-статья] Люди -> Исследователи-путешественники",
      "w|l": "[Вики-статья] Другое -> Ориентиры",
      "w|m": "[Вики-статья] Люди -> Военные деятели",
      "w|o": "[Вики-статья] Другое -> Неизвестно",
      "w|op": "[Вики-статья] Люди -> Не классифицировано",
      "w|p": "[Вики-статья] Люди -> Государственные деятели",
      "w|r": "[Вики-статья] Люди -> Религиозные деятели",
      "w|s": "[Вики-статья] Люди -> Учёные",
      "w|si": "[Вики-статья] Битвы -> Осады"
    },
    "loading": "загружается...",
    "localeWikiNotFound": "Не получается найти статью на английском",
    "map": "",
    "markerIdNameArray": {
      "Artifact": "Артефакт",
      "Artist": "Деятель искусства",
      "Athlete": "Спортсмен",
      "Battle": "Битва",
      "Capital": "Столица",
      "Castle": "Замок",
      "City": "Город",
      "Explorer": "Исследователь-путешественник",
      "Landmark": "Ориентир",
      "Military": "Военный деятель",
      "Politician": "Государственный деятель",
      "Religious": "Религиозный деятель",
      "Scientist": "Ученый",
      "Siege": "Осада",
      "Unclassified": "Не классифицировано",
      "Unknown": "Неизвестно"
    },
    "markerLimit": "Число меток",
    "markerMetadataTypes": {
      "a": "Деятель искусства",
      "ae|culture": "Культура",
      "ae|religion": "Религия",
      "ae|religionGeneral": "Религия (обобщенно)",
      "ae|ruler": "Правитель",
      "ar": "Артефакт",
      "at": "Спортсмен",
      "b": "Битва",
      "c": "Город",
      "ca": "Замок",
      "cp": "Столица",
      "e": "Исследователь-путешественник",
      "ee": "Исследование территорий",
      "ei": "Открытие",
      "eo": "Другие эпопеи",
      "es": "Первоисточник",
      "ew": "Война",
      "l": "Ориентир",
      "m": "Военный деятель",
      "o": "Неизвестно",
      "op": "Не классифицировано",
      "p": "Государственный деятель",
      "ps": "Первоисточник",
      "r": "Религиозный деятель",
      "s": "Учёный",
      "si": "Осада"
    },
    "markers": "Метки",
    "markersMedia": "Метки & Мультимедиа",
    "markerType": "Тип метки",
    "markerTypes": {
      "abstract": "Абстрактные",
      "themed": "Тематические"
    },
    "markerCheckAll": "Select All Marker",
    "markerUncheckAll": "Hide All Marker",
    "mediaTitle": "Мультимедиа: %{dontTranslate}",
    "metadata": "Метаданные",
    "migration": "Миграции",
    "migrationTooltip": "Показать пути людей из места рождения к месту смерти и их агрегацию по областям.",
    "minimize": "Уменьшить",
    "mod": "Изменение",
    "next": "дальше",
    "noLinkedContents": "Ещё нет связанных мультимедиа материалов, пожалуйста добавьте материалы и ссылки на них.",
    "opacityByPopulation": "Непрозрачность по численности населения",
    "openArticle": "Открыть статью",
    "openEpic": "Открыть собственную эпопею",
    "openImage": "Открыть изображение",
    "openSource": "Открыть источник",
    "partOf": "Часть",
    "pledgeOpen": "Открыть Patreon в новой вкладке",
    "pledgeRemind": "Напомните снова через 15 минут",
    "pledgeTitle": "Эй, путешественник!",
    "pointsAdded": "Баллы начислены вашему аккаунту",
    "privacyPolicy": "Политика конфиденциальности",
    "random": "Случайная статья",
    "readDocument": "Читать документ",
    "related_item": "СВЯЗАННЫЕ ОБЪЕКТЫ...",
    "resources": "Ресурсы",
    "revisionHistory": "История правок",
    "revisions": "Правки",
    "allRevisions": "Все правки",
    "search": "Найти",
    "searchMarkers": "Найти метки",
    "setYearByArticle": "Устанавливать год по статье",
    "share": "Поделиться как ссылкой или экспортировать изображение",
    "showProvinces": "Показать области",
    "signupToGatherPoints": "Зарегистрироваться и зарабатывать баллы за курирование данных",
    "skipTutorial": "Я знаю, что делать (пропустить обучение)",
    "startTyping": "Начните вводить",
    "statistics": {
      "area": "Области",
      "edits": "Правки",
      "entities": "Сущности",
      "markers": "Метки",
      "media": "Материалы",
      "replies": "Ответы",
      "threads": "Диалоги",
      "users": "Пользователи"
    },
    "termsofService": "Условия использования",
    "theme": {
      "dark": "Тёмная",
      "font": "Шрифт",
      "light": "Светлая",
      "luther": "Конкордия",
      "marker": "Метка",
      "name": "Тема"
    },
    "timeline": {
      "openAutoplayMenu": "Открыть меню воспроизведения",
      "stopAutoplay": "Остановить воспроизведение",
      "autoplay": "Авто-воспроизведение",
      "autoplaySubtitle": "Менять год шаг за шагом",
      "stepSize": "Шаг в годах",
      "delay": "Задержка в сек.",
      "repeat": "Повторять",
      "startSlideshow": "Запустить слайдшоу",
      "expand": "Раскрыть таймлайн",
      "reset": "Вернуть таймлайн в исходный вид",
      "searchEpics": "Поиск эпопеи"
    },
    "toggle": "Переключить",
    "upvote": "Содержательно и корректно",
    "users": "Администрировать пользователей",
    "welcome": "Добро пожаловать"
  },
  "gallery": {
  },
  "resources": {
    "areas": {
      "fields": {
        "capital": "Столица",
        "color": "Цвет области",
        "culture": "Культура",
        "display_name": "Отображаемое название",
        "endYear": "До какого года",
        "genReligion": "Религия (обобщенно)",
        "icon_url": "Изображение (полный URL ссылки на commons.wikimedia или википедию)",
        "key": "Ключ сущности",
        "main_religion_name": "Название основной религии",
        "main_ruler_name": "Название главного правителя",
        "population": "Население",
        "province": "Область",
        "province_list": "Кликните на область, чтобы выделить её или снять выделение",
        "religion": "Религия",
        "religionGen": "Религия обобщ.",
        "replaceWith": "Заменить на",
        "ruler": "Правитель",
        "search_name": "Выбрать по названию",
        "startYear": "С какого года",
        "wiki_url": "Статья (полная URL-ссылка на википедию)"
      }
    },
    "linked": {
      "fields": {
        "content": "Описание",
        "description": "Заголовок",
        "geojson": "Geojson (для эпопей)",
        "onlyEpicContent": "Использовать только как составную часть, ассоциированную с другой статьей (при сохранении вас перенаправит к редактированию ассоциации)",
        "poster": "Ссылка на эмблему",
        "source": "Ссылка на источник",
        "src": "Ссылка на источник/ ID",
        "subtype": "Тип",
        "wiki": "Связанная статья Википедии",
        "year": "Год"
      }
    },
    "flags": {
      "fields": {
        "fixed": "Resolved",
        "subEntityId": "SubEntityId",
        "fullUrl": "FullUrl",
        "wrongWiki": "wrongWiki"
      }
    },
    "links": {
      "fields": {
        "content_list": "Элементы, отображаемые в оглавлении (секция слева)",
        "media_list": "Элементы, отображаемые в мультимедийных материалах",
        "source": "Исходная статья, получающая ссылки"
      }
    },
    "markers": {
      "deleted": "Метка удалена",
      "fields": {
        "capitalEnd": "Год окончания",
        "capitalOwner": "Правитель столицы",
        "capitalStart": "Год начала",
        "coo": "Координаты",
        "date": "Дата",
        "endYear": "Год окончания",
        "lastUpdated": "Последнее обновление",
        "lat": "Широта",
        "lng": "Долгота",
        "name": "Название",
        "rating": "Рейтинг",
        "startYear": "Год начала",
        "subtype": "Подтип",
        "type": "Тип",
        "url": "URL",
        "year": "Год"
      },
      "name": "Метка |||| Метки",
      "place_marker": "Разместить метку",
      "tabs": {
        "address": "Адрес",
        "identity": "Личность",
        "orders": "Заказы",
        "reviews": "Рецензии",
        "stats": "Статистика"
      }
    },
    "page": {
      "delete": "Удалить"
    },
    "revisions": {
      "fields": {
        "entityId": "Id сущности",
        "id": "Id",
        "name": "Название",
        "nextBody": "Новое содержимое",
        "prevBody": "Старое содержимое",
        "resource": "Ресурс",
        "reverted": "Отменено",
        "subtype": "Подтип",
        "timestamp": "Время",
        "type": "Тип",
        "user": "Пользователь"
      },
      "name": "Правка |||| Правки"
    },
    "users": {
      "fields": {
        "createdAt": "Создан",
        "education": "Образование",
        "email": "Email",
        "karma": "Карма",
        "name": "Имя",
        "privilege": "Привилегии",
        "username": "Username"
      },
      "name": "Пользователь |||| Пользователи",
      "page": {
        "delete": "Удалить аккаунт"
      },
    }
  },
  "somethingWentWrong": "Что-то пошло не так"
}
